/* eslint-disable no-param-reassign */

/**
 *
 * Flatten nested field errors
 *
 * @param errors
 * @returns {{}}
 */
export const flattenErrors = errors => {
  const result = {};

  const stack = Object.keys(errors).map(key => [key, errors[key]]);

  while (stack.length) {
    const [key, value] = stack.pop();

    // Note: watch out for Immutable types!
    const isArray = Array.isArray(value);
    const isObject = !isArray && typeof value === "object";

    if (isObject) {
      Object.keys(value).forEach(nestedKey => {
        stack.push([`${key}.${nestedKey}`, value[nestedKey]]);
      });
    } else {
      result[key] = value;
    }
  }

  return result;
};

/**
 * Return object containing form errors for given response error.
 * Each item is array of strings.
 * Item under key '' contains non-field errors.
 *
 * @param error
 * @returns {*}
 */
export const parseRequestError = error => {
  let result = null;
  const data = error.data;
  try {
    if (data.detail && data.detail.fields === undefined) {
      // Non-validation exception
      result = { "": [data.message] };
    } else {
      // Validation exception
      result = data.detail.fields;
    }
  } catch (e) {
    console.warn("No input errors found? Message: ", error.message);
  }
  if (result === null || result === undefined) {
    result = { "": [`Unexpected error (${error.code}).`] };
  } else {
    result = flattenErrors(result);
  }
  return result;
};

export const getInputValue = (input, minMax) => {
  let value;
  if (input.type === "checkbox") {
    value = input.checked;
  } else if (input.type === "number" || input.type === "range") {
    value = parseFloat(input.value);
    if (minMax) {
      if (value > minMax.max) {
        value = minMax.max;
      } else if (value < minMax.min) {
        value = minMax.min;
      }
    }
  } else if (input.type === "select-multiple") {
    const optionsNodeList = input.querySelectorAll("option");
    const options = Array.prototype.slice.call(optionsNodeList);
    const selected = options.filter(option => option.selected);
    value = selected.map(option => option.value);
  } else if (input.value) {
    value = input.value;
  } else {
    // this is for 'custom' form elements made of divs, like Autosuggest
    value = input.innerHTML;
  }
  return value;
};
